import ScrollReveal from 'stimulus-scroll-reveal';

export default class extends ScrollReveal {
  connect() {
    super.connect();
  }
}
